module.exports = __webpack_public_path__ + "static/Ranger 2-65847fbff9d33b5303c416754861f34b.jpg";